(function () {
  'use strict';

  var DURATION = '0.30s';
  var EASING   = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function initGallery(gallery) {
    if (gallery.dataset.galleryInitialized) return;
    gallery.dataset.galleryInitialized = 'true';

    var img     = gallery.querySelector('.card-gallery__img');
    var prevBtn = gallery.querySelector('.card-gallery__btn--prev');
    var nextBtn = gallery.querySelector('.card-gallery__btn--next');

    if (!img || !prevBtn || !nextBtn) return;

    var rawUrls = gallery.dataset.galleryImages || '';
    var urls    = rawUrls.split('|').filter(Boolean);
    if (urls.length <= 1) return;

    var currentIndex = 0;
    var animating    = false;
    var preloaded    = false;

    // ── Preload all images the moment the user hovers the card ──────────────
    // Images are fetched + decoded into the browser cache so subsequent
    // src swaps are instant, matching Retrofete's seamless behaviour.
    function preloadAll() {
      if (preloaded) return;
      preloaded = true;
      for (var i = 1; i < urls.length; i++) {
        var p    = new Image();
        p.decoding = 'async';
        p.src    = urls[i];
      }
    }
    gallery.addEventListener('mouseenter', preloadAll, { once: true });
    gallery.addEventListener('touchstart',  preloadAll, { passive: true, once: true });

    // ── Slide navigation ────────────────────────────────────────────────────
    function navigate(direction) {
      if (animating) return;

      // Ensure images are preloaded even if the user clicked without hovering
      preloadAll();

      animating    = true;
      currentIndex = (currentIndex + direction + urls.length) % urls.length;

      var mediaDiv = img.parentNode;
      var fromX    = direction > 0 ? '100%'  : '-100%';
      var toX      = direction > 0 ? '-100%' : '100%';
      var trans    = 'transform ' + DURATION + ' ' + EASING;

      // Create the incoming image element — src hits the cache, so it renders
      // immediately without a blank flash
      var incoming      = new Image();
      incoming.src      = urls[currentIndex];
      incoming.alt      = img.alt;
      incoming.decoding = 'sync'; // use cached + decoded version
      incoming.className = 'card-gallery__img';

      // ── Step 1: set start positions with transitions disabled ────────────
      img.style.transition      = 'none';
      img.style.transform       = 'translateX(0)';
      incoming.style.transition = 'none';
      incoming.style.transform  = 'translateX(' + fromX + ')';

      mediaDiv.appendChild(incoming);

      // Force the browser to flush styles so both start positions are committed
      void incoming.offsetWidth;

      // ── Step 2: enable transitions and set target positions ──────────────
      img.style.transition      = trans;
      incoming.style.transition = trans;
      img.style.transform       = 'translateX(' + toX + ')';
      incoming.style.transform  = 'translateX(0)';

      // ── Step 3: clean up after the slide completes ───────────────────────
      incoming.addEventListener('transitionend', function onDone() {
        incoming.removeEventListener('transitionend', onDone);

        var oldImg = img;
        img = incoming;

        oldImg.remove();

        // Only clear the inline animation styles — position/size stay from CSS
        img.style.transform  = '';
        img.style.transition = '';

        animating = false;
      });
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      navigate(-1);
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      navigate(1);
    });
  }

  function initAll() {
    document.querySelectorAll('.card-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Ajaxinate "load more" injects new cards
  document.addEventListener('ajaxinate:updated', function () {
    document.querySelectorAll('.card-gallery:not([data-gallery-initialized])').forEach(initGallery);
  });

  // MutationObserver fallback: catch any new .card-gallery elements added to
  // the DOM (e.g. via Ajaxinate load-more or infinite scroll callbacks that
  // don't fire the ajaxinate:updated event)
  var observer = new MutationObserver(function (mutations) {
    var found = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { found = true; break; }
    }
    if (!found) return;
    document.querySelectorAll('.card-gallery:not([data-gallery-initialized])').forEach(initGallery);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
